import React from 'react';
import '../../styles/collaborators/collaborators.css';
import brukerLogo from '../../assets/img/Bruker_logo.png';

const AzTeam = () => {

	return (
		<section className="brukerSection">
            <span className="text-content">
				<h2>Bruker Team</h2>
				<p>
					Bruker Team  consist of local application specilist and international R&D team supporting the ProMS development. The local team is 
					heade by Renata Blatnik who is an experienced field application specialist for proteomics and the international team by Dr Gary Kruppa 
					serves as the Vice President for proteomics at Bruker Daltonics Inc. He manages a growing global team of applications, field applications 
					and applications development scientists, focused on developing new proteomics applications and supporting collaborators.
				</p>
			</span>
			<span className="logo-encasing">
				<img
					src={brukerLogo}
					alt="Beckman Logo"
					className="beckmanLogo"
				/>
			</span>
		</section>
	);
};

export default AzTeam;
